//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';

// custom pages
import Context from 'context/context';
import './css/Location.css';
import { locationStyles } from './styles';
import locationApi from 'apis/location/location';
import access from 'config/access';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import auth from "apis/auth/auth";

// material-ui
import { Grid, Button, Typography } from '@material-ui/core'


export default function DormantView() {
    const { state, dispatch } = useContext(Context);
    const { dormantaccount } = locationApi();
    const { isLoggedIn } = auth();
    const history = useHistory();
    const location = useLocation();
    const [btnLoading, setBtnLoading] = useState(false); 

    // For bread-crumbs
    useEffect(() => {
        dispatch({
            type: 'SET_PATHNAME',
            payload: ['HOME', 'My Account'],
        });
    }, []);


    useEffect(() => {
        handleMarketingAdminFunc();
    }, [state.ALA]);

    useEffect(() => {
        handleredirect()
    }, [])

    const handleredirect = () => {
        if (!state?.ALA?.["Loyalty_Account.dormant_account_flag"]) {
            return history.push("/dashboard/mydashboard");
        }
    };

    const handleMarketingAdminFunc = () => {
        if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
            if (state?.ALA && Object.keys(state?.ALA).length > 0) {
                return;
            }
            return history.push("/dashboard/loyalty");
        }
    };

    async function handledromantaccount() {
        try {
            let values = {
                memberId: state?.ALA?.loyalty_id,
                shipto: state?.ACA?.customer_account_number
            };
            setBtnLoading(true);
            let res = await dormantaccount(values);
            if (res.status === 'SUCCESS') {
                let res1 = await isLoggedIn();
                if (res1 && Object.keys(res1).length > 0 && res1?.user) {
                    dispatch({ type: "SET_ALA", payload: res1?.loyaltyAccount });
                    history.push('/dashboard/mydashboard')
                    return;
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setBtnLoading(false);
        }
    }

    return (
        <React.Fragment>
            <NewUI handledromantaccount={handledromantaccount} btnLoading={btnLoading} />
        </React.Fragment>
    );
}

const NewUI = ({ handledromantaccount, btnLoading }) => {
    const paragraphStyle = {
        textAlign: 'center',
        fontSize: 16
    };
    const buttonStyle = {
        fontSize: 16,
        background: '#0a72ba',
        border: 'none',
        color: '#fff',
        borderRadius: 5,
        padding: '6px 16px',
        cursor: 'pointer',
    };
    return (
        <div
            className='container'
        >
            <div style={{ fontSize: 22, fontWeight: 600, textAlign: 'center' }}>Your Thrive Rewards Account is Dormant</div><br />
            <p style={paragraphStyle}>Your account became dormant because rewards points were not redeemed in the past 24 months.</p>
            <div style={paragraphStyle}>Reactivating your account allows you to start earning Thrive Rewards points again and helps to ensure your</div>
            <div style={paragraphStyle}>Thrive service benefits remain available</div><br />
            <div style={{ textAlign: 'center' }}>
                <button style={buttonStyle} onClick={handledromantaccount}>{btnLoading ? "Loading..." : "Activate My Account"}</button>
            </div><br />
            <div style={{ fontSize: 16, fontWeight: 600 }}>Need Help?</div>
            <div style={{ fontSize: 16 }}>If you have questions about your Thrive membership or need further assistance, our team is here to help.</div>
            <Typography variant="body2" style={{ color: '#1f66b8', textDecoration: 'underline' }} component="p">
                <a
                    href="https://outlook.office.com/mail/deeplink/compose?to=ThriveRewards@HenrySchein.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Contact Thrive Support
                </a>
            </Typography>
        </div>
    );
}

// function OldUI() {
    //     return (
    //         <div
    //             className='container'
    //         >
    //             <Grid container spacing={0} style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-start' }}>
    //                 {state?.ALA?.["Loyalty_Account.dormant_account_flag"] == true ?
    //                     <Grid item xs={12} sm={6} lg={6} style={{ paddingRight: 20, maxWidth: '40%' }}>
    //                         <Typography variant="body1" color="textPrimary" style={{ display: 'flex' }}>
    //                             <p style={{ color: '#3b5d89', fontSize: 18, fontWeight: 600 }}> Your Points Status:</p> <p style={{ color: '#ef3b41', fontSize: 18, fontWeight: 600 }}>Inactive</p>
    //                         </Typography>
    //                         <Typography variant="body2" style={{ color: '#486790', fontSize: 15 }} paragraph>
    //                             It looks like you haven't used your rewards points in the past 24 months, so earning has been temporarily turned off. To start earning rewards again, just click the button below.
    //                         </Typography>
    //                         <Button variant="contained" style={{ background: '#8f1e5f', marginBottom: 113, color: 'white' }} onClick={() => handledromantaccount()} >
    //                             Start Earning Points
    //                         </Button>
    //                         <Typography variant="body2" color="textPrimary" paragraph>
    //                             Need Help?
    //                         </Typography>
    //                         <Typography variant="body2" style={{ color: '#1f66b8', textDecoration: 'underline' }} component="p">
    //                             <a
    //                                 href="https://outlook.office.com/mail/deeplink/compose?to=ThriveRewards@HenrySchein.com"
    //                                 target="_blank"
    //                                 rel="noopener noreferrer"
    //                             >
    //                                 - Contact Support
    //                             </a>
    //                         </Typography>
    //                     </Grid> :
    //                     <Grid item xs={12} sm={6} lg={6} style={{ paddingRight: 20, maxWidth: '40%' }}>
    //                         <Typography variant="body1" color="textPrimary" style={{ display: 'flex' }}>
    //                             <p style={{ color: '#3b5d89', fontSize: 18, fontWeight: 600 }}> Your Points Status:</p><p style={{ color: '#3aba60', fontSize: 18, fontWeight: 600 }}>Active</p>
    //                         </Typography>
    //                         <Typography variant="body2" style={{ marginBottom: 100 }} paragraph>
    //                             <strong style={{ color: '#3b5d89', fontSize: 18, display: 'flex', alignItems: 'center', fontWeight: 600 }}>Points Earning Since: <p style={{ marginBottom: 0 }}>{dormantAccount?.thrivedate}</p></strong>
    //                             <strong style={{ color: '#486790', fontSize: 15, display: 'flex', alignItems: 'center', marginBottom: 10, marginTop: 10 }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Earn Points On All Purchases</strong>
    //                             <strong style={{ color: '#486790', fontSize: 15, display: 'flex', alignItems: 'center', marginBottom: 10, marginTop: 10 }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Prorepair 2X Points</strong>
    //                             <strong style={{ color: '#486790', fontSize: 15, display: 'flex', alignItems: 'center', marginBottom: 10, marginTop: 10 }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Limited-Time Promotions</strong>

    //                         </Typography>
    //                         <Typography variant="body2" style={{ color: '#1f66b8', textDecoration: 'underline' }} component="p">
    //                             <a
    //                                 href="https://outlook.office.com/mail/deeplink/compose?to=ThriveRewards@HenrySchein.com"
    //                                 target="_blank"
    //                                 rel="noopener noreferrer"
    //                             >
    //                                 Have questions? Contact Support
    //                             </a>
    //                         </Typography>
    //                         {/* <Typography variant="body2" style={{color:'#1f66b8',textDecoration: 'underline'}}component="p">
    //                                         - Contact Support or Visit Our FAQs
    //                                     </Typography> 
    //                                 */}
    //                     </Grid>}
    //                 {/* Center Divider (Vertical Line) */}
    //                 <Grid item xs={1} style={{ borderLeft: '1px solid #000', height: 'auto', alignSelf: 'stretch' }} />


    //                 {/* Right Column */}
    //                 <Grid item xs={12} sm={5} lg={5} style={{ paddingLeft: 20 }}>
    //                     <Typography variant="body1" color="textPrimary" style={{ display: 'flex' }}>
    //                         <p style={{ color: '#3b5d89', fontSize: 18, fontWeight: 600 }}>Your Benefit Status:</p> <p style={{ color: '#3aba60', fontSize: 18, fontWeight: 600 }}>Active</p>
    //                     </Typography>

    //                     <Typography variant="body2" color="textSecondary" paragraph>
    //                         <strong style={{ color: '#3b5d89', fontSize: 18, display: 'flex', alignItems: 'center' }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Service & Repair</strong>
    //                         <ul style={{ color: '#486790', listStyleType: 'none', paddingLeft: 57 }}>
    //                             <li > - Labor Discount</li>
    //                             <li>  - Priority Scheduling for In-Office repairs</li>
    //                             <li> - Guaranteed Emergency Response</li>
    //                             <li> - ProRepair Service Discount</li>
    //                         </ul>
    //                         <strong style={{ color: '#3b5d89', fontSize: 18, display: 'flex', alignItems: 'center' }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Equipment</strong>
    //                         <ul style={{ color: '#486790', listStyleType: 'none', paddingLeft: 57 }}>
    //                             <li>- Extended Labor Warranty</li>
    //                         </ul>
    //                         <strong style={{ color: '#3b5d89', fontSize: 18, display: 'flex', alignItems: 'center' }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Education & Business Solutions</strong>
    //                         <ul style={{ color: '#486790', listStyleType: 'none', paddingLeft: 57 }}>
    //                             <li>- Discounts</li>
    //                         </ul>
    //                         <strong style={{ color: '#3b5d89', fontSize: 18, display: 'flex', alignItems: 'center' }}><CheckCircleOutlineIcon style={{ fontSize: 22, color: 'green' }} />Concierge Service</strong>
    //                     </Typography>
    //                 </Grid>
    //             </Grid>
    //         </div>
    //     );
    // }
